import React from "react";
import PropTypes from "prop-types";
import { Box, Chip, Tooltip } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Icon } from "@iconify/react";

export default function EventMetaChips({
  event,
  isTesting,
  eventTypeLabel,
  statusLabel,
  statusColor,
  accentColor,
}) {
  const isBooking = event?.registrationType === "booking";

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.7 }}>
      <Chip
        size="small"
        label={eventTypeLabel}
        sx={{
          bgcolor: alpha(accentColor, 0.16),
          color: accentColor,
          fontWeight: 700,
          border: `1px solid ${alpha(accentColor, 0.35)}`,
        }}
        icon={isTesting ? <Icon icon="mdi:medal" width={14} /> : undefined}
      />

      {isBooking ? (
        <Tooltip
          title="Diese Veranstaltung nutzt den Buchungsmodus mit Anmeldungsverwaltung."
          placement="top"
        >
          <Chip
            size="small"
            color="secondary"
            icon={<Icon icon="mdi:ticket-confirmation-outline" width={14} />}
            label="Booking"
          />
        </Tooltip>
      ) : null}

      {statusLabel ? <Chip size="small" color={statusColor} label={statusLabel} /> : null}

      <Tooltip
        title={
          event?.isPublic
            ? "Diese Veranstaltung ist für Mitglieder im Portal sichtbar."
            : "Diese Veranstaltung ist intern und nicht für Mitglieder sichtbar."
        }
        placement="top"
      >
        <Chip
          size="small"
          color={event?.isPublic ? "success" : "default"}
          variant={event?.isPublic ? "filled" : "outlined"}
          icon={
            <Icon
              icon={event?.isPublic ? "mdi:eye-outline" : "mdi:eye-off-outline"}
              width={14}
            />
          }
          label={event?.isPublic ? "Öffentlich" : "Intern"}
        />
      </Tooltip>

      {event?.isFeeBased ? (
        <Tooltip
          title={`Teilnahmegebühr: ${Number(event?.feeAmount || 0).toFixed(2)} EUR`}
          placement="top"
        >
          <Chip size="small" color="warning" variant="outlined" label="Kostenpflichtig" />
        </Tooltip>
      ) : null}
    </Box>
  );
}

EventMetaChips.propTypes = {
  event: PropTypes.shape({
    isPublic: PropTypes.bool,
    isFeeBased: PropTypes.bool,
    feeAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    registrationType: PropTypes.string,
  }),
  isTesting: PropTypes.bool,
  eventTypeLabel: PropTypes.string.isRequired,
  statusLabel: PropTypes.string,
  statusColor: PropTypes.string,
  accentColor: PropTypes.string.isRequired,
};

EventMetaChips.defaultProps = {
  event: null,
  isTesting: false,
  statusLabel: "",
  statusColor: "default",
};
